'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getParents() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      index = _ref.index,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField;

  return function (rows) {
    var parents = [];
    var currentIndex = index;
    var cell = rows[index];
    var searchingParent = void 0;

    if (!cell || (0, _isNil3.default)(cell[parentField])) {
      return parents;
    }

    while (cell) {
      if (typeof searchingParent === 'undefined') {
        searchingParent = cell[parentField];
      } else if (searchingParent === cell[idField]) {
        parents.unshift(cell);
        searchingParent = cell[parentField];
      }

      if (cell[parentField] === null || typeof cell[parentField] === 'undefined') {
        break;
      }

      currentIndex -= 1;
      cell = rows[currentIndex];
    }

    return parents;
  };
}

exports.default = getParents;